import { ReactElement } from "react";
import { Footer as MameFooter } from "../../styles/mame-styled/core/HtmlTag";

export default function Footer(): ReactElement {
  return <>
    <MameFooter>
      {/* logo - brand */}
      {/* author */}
      {/* contact author */}
    </MameFooter>
  </>;
}
